import { createReducer, on } from '@ngrx/store';
import {
  deleteSessionSuccess,
  readSession,
  readSessionFailure,
  readSessions,
  readSessionsFailure,
  readSessionsSuccess,
  readSessionSuccess,
  restoreSessionSuccess,
  updateSessionSuccess,
} from './session.actions';
import { SessionDto } from '@shared/dto';
import { PaginatedListQuery } from '@shared/interfaces/paginated-list-query.interface';
import { logout } from '@auth/store/auth.actions';
import { State } from '@store/state.interface';

export const SESSION_FEATURE_KEY = 'sessions';

export interface SessionState extends State<SessionDto> {}

export const initialState: SessionState = {
  data: null,
  detail: null,
  total: 0,
  query: null,
  loading: false,
  error: null,
};

export const sessionReducer = createReducer(
  initialState,
  on(readSessions, (state, { query }) => ({
    ...state,
    query: query ?? state.query,
    loading: true,
    error: null,
  })),
  on(readSessionsSuccess, (state, { data, total }) => ({ ...state, data, total, loading: false })),
  on(readSessionsFailure, (state, { error }) => ({ ...state, loading: false, error })),
  // Detail (single entity): the resolver blocks activation and matches by id, so we
  // keep the previous detail during the load (no blank flash on the outgoing page).
  on(readSession, (state) => ({ ...state, loading: true, error: null })),
  on(readSessionSuccess, (state, { session }) => ({ ...state, detail: session, loading: false })),
  on(readSessionFailure, (state, { error }) => ({ ...state, loading: false, error })),
  // Keep the open detail in sync with mutations so the form/restore-banner stay
  // correct without a refetch (the list itself is refetched by reloadAfterMutation$).
  on(updateSessionSuccess, (state, { session }) => ({
    ...state,
    detail: state.detail ? { ...state.detail, ...session } : state.detail,
  })),
  on(deleteSessionSuccess, (state, { session }) => ({ ...state, detail: session })),
  on(restoreSessionSuccess, (state, { session }) => ({ ...state, detail: session })),
  // Create/update/delete/restore change the page contents or totals, so the
  // current page is refetched (see SessionEffects.reloadAfterMutation$) rather
  // than mutated in place — which would desync the paginator.
  on(logout, () => initialState),
);
